<div class="upload-window">
    <div *ngIf="files.length == 0" class="upload-picker" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" [class.dragover]="dragOver">
        <mat-icon class="upload-picker-icon" *ngIf="!dragOver"> insert_drive_file</mat-icon>
        <button *ngIf="!dragOver" mat-raised-button color="primary" (click)="file.click()"
            style="margin-bottom:10px">Upload files</button>
        <p *ngIf="!dragOver">or drop files here</p>
        <p *ngIf="dragOver">Drop files</p>

    </div>
    <div *ngIf="files.length != 0" class="upload-picker" (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" [class.dragover]="dragOver">
        <div class="uploaded-files" *ngIf="!dragOver">
            <div
                style="display: flex; flex-direction: row; gap: 10px; align-items: center; justify-content: center; width: 100%;">
                <button mat-raised-button color="primary" (click)="file.click()" style="margin-bottom:10px">Upload
                    files</button>
                <p *ngIf="!dragOver">or drop files here</p>
            </div>
            <div *ngFor="let file of files" class="single-file-view">
                <div style="display: flex; flex-direction: row; align-items: end; width: 100%;">
                    <button mat-icon-button disabled="true">
                        <mat-icon *ngIf="file.file.type.includes('image')">image</mat-icon>
                        <mat-icon *ngIf="file.file.type.includes('pdf')">picture_as_pdf</mat-icon>
                        <mat-icon
                            *ngIf="!file.file.type.includes('image') && !file.file.type.includes('pdf')">
                            insert_drive_file
                        </mat-icon>
                    </button>

                    <p class="file-name">{{ file.file.name}}</p>
                    <div class="example-spacer"></div>
                    <button mat-icon-button *ngIf="!file.uploaded" (click)="onCancel($event, file)">
                        <mat-icon>close</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="file.uploaded" disabled="true">
                        <mat-icon color="primary">check</mat-icon>
                    </button>
                </div>

                <mat-progress-bar mode="determinate" [value]="file.progress"
                    *ngIf="file.isUploading"></mat-progress-bar>
            </div>

        </div>

        <p *ngIf="dragOver">Drop files</p>
    </div>

</div>
<input type="file" [accept]="acceptedFileTypes" multiple #file [style.visibility]="'hidden'"
    (change)="onFileSelected($event)">